import { useNavigate } from 'react-router-dom'
import style from './ConnectionTabMobile.module.css'
import ArrowLeftIcon from '../../../../assets/svgs/ArrowLeft'
import ConnectionsChoices from '../Profile/ConnectionsChoices'
import { useState } from 'react'
import { PersonalChartsData } from '../../../../dummyData'
const PersonalCharts = () => {
  const navigate = useNavigate()
  const [openCard, setOpenCard] = useState()
  const cardToggle = (value) => {
    if (openCard === value) {
      setOpenCard(null)
    } else {
      setOpenCard(value)
    }
  }

  return (
    <div className={style.personalChartContainer}>
      <p className={style.back} onClick={() => navigate('/dashboard/connect')}>
        <ArrowLeftIcon /> Back to Connect
      </p>
      <div className={style.chartCardsContainer}>
        <div className={style.chartSingleCard}>
          <p className={style.chartNumber}>20</p>
          <p className={style.chartText}>events attended</p>
        </div>
        <div className={style.chartSingleCard}>
          <p className={style.chartNumber}>150</p>
          <p className={style.chartText}>connections</p>
        </div>
        <div className={style.chartSingleCard}>
          <p className={style.chartNumber}>200</p>
          <p className={style.chartText}>conversations</p>
        </div>
        <div className={style.chartSingleCard}>
          <p className={style.chartNumber}>25</p>
          <p className={style.chartText}>interactions</p>
        </div>
      </div>
      <p className={style.choicesTitle}>Your connections' choices</p>
      <div className={style.connectionsContainer}>
        <ConnectionsChoices
          data={PersonalChartsData}
          cardToggle={cardToggle}
          openCard={openCard}
          noTitle={true}
        />
      </div>
    </div>
  )
}
export default PersonalCharts
